<div class='configuration-commitments-tab1-part'>
	This is configuration-commitments tab 1
</div>